import React, { useState } from 'react'
import axios from 'axios'
import { Modal, message } from 'antd'
import MyInput from '../components/input'
import MyUpload from '../components/upload'

const EditProfile = (props) => {
  const [formValue, setFormValue] = useState({
    avatar: props.data.info.avatar,
    nickname: props.data.info.nickname
  })
  const [errorMsg, setErrorMsg] = useState({})

  const handleOk = () => {
    setErrorMsg({})
    if (!formValue.nickname) {
      setErrorMsg({nicknameEmpty: '昵称不能为空'})
      return
    }

    axios.post('/c/kf_b/account/edit', { 
      avatar: formValue.avatar,
      nickname: formValue.nickname,
    })
      .then(function (response) {
        if (response.errcode === 0) {
          handleCancel()
          props.fetchAcountDetail()
          message.success('修改成功！')
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  const handleCancel = () => {
    setErrorMsg({})
    props.isCancel()
  }

  return (
    <Modal 
      title='编辑资料'
      destroyOnClose={true}
      width='500px'
      open={props.isOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      cancelText="取消"
      okText="保存">

      <MyUpload 
        id="avatar"
        label='头像'
        value={formValue.avatar}
        setValue={setFormValue}
      />

      <MyInput
        id="nickname"
        required
        autoFocus
        maxLength={64}
        label='昵称'
        placeholder='请输入对外展示的昵称'
        value={formValue.nickname}
        onChange={setFormValue}
        errorMsg={errorMsg.nicknameEmpty}
      />
    </Modal>
  )
}

export default EditProfile
